import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatAiLummyComponent } from './chat-ai-lummy.component';
import { ChatAiOpenComponent } from './components/chat-ai-open/chat-ai-open.component';
import { LottieComponent } from 'ngx-lottie';
import { AvatarModule } from 'primeng/avatar';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [ChatAiLummyComponent,ChatAiOpenComponent],
  imports: [
    CommonModule,
    LottieComponent,
    AvatarModule,
    OverlayPanelModule,
    InputTextModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    MessagesModule,
  ],
  exports:[
    ChatAiLummyComponent,
    ChatAiOpenComponent
  ]
})
export class ChatAiLummyModule { }
